<template>
    <div class="mt-4">
        <ContentCard v-if="forum" class="mt-4" :link="link(forum)">
            <div class="row align-items-center">
                <div class="col ml-1" >
                   <h4 class="mb-0">
                        <span>{{course.translation ? course.translation.name : ''}}</span>
                    </h4>
                </div>
                <div class="col-auto nch--content-color">
                    <i class="mdi mdi-36px mdi-forum"></i>
                </div>
            </div>
        </ContentCard>
        <ContentCard v-for="forum in forums" :key="forum.id" class="mt-4" :link="link(forum)">
            <div class="row align-items-center">
                <div class="col ml-1" >
                   <h4 class="mb-0">
                        <span>{{forum.name}}</span>
                    </h4>
                </div>
                <div class="col-auto nch--content-color">
                    <i class="mdi mdi-36px mdi-forum"></i>
                </div>
            </div>
        </ContentCard>
        <loading-spinner
            v-if="loading"
        ></loading-spinner>
        <Empty
            v-if="!forum && !forums.length"
            class="my-6"
            :icon="'mdi mdi-cancel'">
            <template #title><h1 class="font-weight-medium mb-0">{{$t('common.no_forum')}}</h1></template>
        </Empty>
    </div>
</template>

<script>
import CollapseItem from '../../argon/components/Collapse/CollapseItem'
import Collapse from '../../argon/components/Collapse/Collapse'

import ContentCard from '../Common/ContentCard'
import LoadingSpinner from '../Common/LoadingSpinner'
import Empty from '../Common/Empty'

export default {
    name: 'CourseForum',
    components: {
        CollapseItem,
        Collapse,
        ContentCard,
        LoadingSpinner,
        Empty
    },
    props: {
        active : {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            forums: [],
            loading: true
        }
    },
    watch: {
        active(value) {
            if (value) return this.getForums()
        }
    },
    computed: {
        language() {
            return this.$store.getters.LANGUAGE
        },
        plan() {
            return this.$store.getters.PLAN
        },
        course() {
            return this.$store.getters.COURSE
        },
        forum() {
            return this.$store.getters.FORUM
        }
    },
    methods: {
        getForums(page = false) {
            this.loading = true

            window.axios
                .get(`/api/app/plan/${this.plan}/course/${this.course.id}/forums`, {
                    params: {
                        iso: this.language.iso
                    }
                })
                .then(res => this.forums = res.data.data)
                .catch(err => console.error(err))
                .finally(() => this.loading = false)
        },
        link(forum) {
            return `/app/plan/${this.plan}/${forum.type}/forum/${forum.id}?ref=${window.location.pathname}`
        }
    }
}
</script>

<style>

</style>
